module.exports = __webpack_public_path__ + "img/fly-talks.60551092.png";